module.exports = __webpack_public_path__ + "img/11 (copy).6e5e245b.jpg";